var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Part6"},[_c('div',{staticClass:"w"},[_c('div',{staticClass:"titleBlack"},[_c('div',[_vm._v("一村合作伙伴")])]),_c('img',{attrs:{"src":require("@/assets/image/banner/part11.png"),"alt":""}})])])
}]

export { render, staticRenderFns }